module.exports = __webpack_public_path__ + "images/rorlogo-7148cb51a329d76f1058825d31d46ee2.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/rorlogo.png
// module id = 210
// module chunks = 0